module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/en/4-b8066d0ab900e38140db9793a045c8c6.jpg";